<template>
  <div class="compressed-content">
    <h3>Do you have chronic kidney disease (CKD)?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hasCKD">
      <b-form-radio v-model="survey.medicalConditions.chronicKidneyDisease.hasCKD" name="ckd"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.chronicKidneyDisease.hasCKD" name="ckd"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hasCKD: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hasCKD() { return this.survey.medicalConditions.chronicKidneyDisease.hasCKD; }
    }
  };
</script>